// extracted by mini-css-extract-plugin
export default {"button":"InviteUsers-button-6f6ea37c48bbdf1c0f867bbd962cd3e3"};